import React, { useMemo, useState } from 'react';
import { Image, ImageBackground, PixelRatio } from 'react-native';
import { isCdnUrl, process, updateDefaultConfig } from './utils';
updateDefaultConfig({
    getPixelSizeForLayoutSize: (value) => PixelRatio.getPixelSizeForLayoutSize(value),
});
const useUri = (source, cdnCutOption) => {
    return useMemo(() => {
        // 对cdn链接做处理
        if (isCdnUrl(source)) {
            if (cdnCutOption && typeof source.uri === 'string') {
                return [false, process(source.uri, cdnCutOption)];
            }
            return [false, source.uri];
        }
        return [true, source];
    }, [cdnCutOption, source]);
};
const RTXImage = (props) => {
    var _a, _b, _c;
    const [localImg, uri] = useUri(props.source || {}, props.cdnCutOption);
    let source = props.source;
    if (!localImg) {
        source = Object.assign(Object.assign({}, source), { uri });
    }
    const [index, setIndex] = useState(0);
    if ((_a = source.uris) === null || _a === void 0 ? void 0 : _a.length) {
        if (props.children) {
            return (React.createElement(ImageBackground, Object.assign({}, props, { source: {
                    uri: (_b = source.uris[index]) === null || _b === void 0 ? void 0 : _b.url,
                }, onError: (e) => {
                    if (index < source.uris.length - 1) {
                        setIndex(index + 1);
                    }
                    props === null || props === void 0 ? void 0 : props.onError(e);
                } }), props.children));
        }
        return (React.createElement(Image, Object.assign({}, props, { source: {
                uri: (_c = source.uris[index]) === null || _c === void 0 ? void 0 : _c.url,
            }, onError: (e) => {
                if (index < source.uris.length - 1) {
                    setIndex(index + 1);
                }
                props === null || props === void 0 ? void 0 : props.onError(e);
            } })));
    }
    if (props.children) {
        return (React.createElement(ImageBackground, Object.assign({}, props, { source: source }), props.children));
    }
    return React.createElement(Image, Object.assign({}, props, { source: source }));
};
const resizeMode = {
    contain: 'contain',
    cover: 'cover',
    stretch: 'stretch',
    center: 'center',
};
const priority = {
    low: 'low',
    normal: 'normal',
    high: 'high',
};
const cacheControl = {
    // Ignore headers, use uri as cache key, fetch only if not in cache.
    immutable: 'immutable',
    // Respect http headers, no aggressive caching.
    web: 'web',
    // Only load from cache.
    cacheOnly: 'cacheOnly',
};
RTXImage.resizeMode = resizeMode;
RTXImage.cacheControl = cacheControl;
RTXImage.priority = priority;
RTXImage.preload = () => { };
export default React.memo(RTXImage);
